"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULES = void 0;
var MODULES;
(function (MODULES) {
    MODULES["VMDS"] = "VMDSModule";
    MODULES["VEHICLE_SELECTOR"] = "VehicleSelector";
    MODULES["CAR_CONFIGURATION"] = "FcisCalculationApiModule";
})(MODULES || (exports.MODULES = MODULES = {}));
